import Sider from "antd/es/layout/Sider";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/svg/lightModeLogo.svg";
import darkModeLogo from "../../assets/svg/darkModeLogo.svg";
import MenuItems from "./MenuItems";
import clsx from "clsx";
import StorageDetails from "./StorageDetails";
import { useTheme } from "../../hooks/useTheme";
import { Spin } from "antd";
import { getFileCount, getTotalVolume } from "../../redux/action/file";

const Aside = ({ isMobileMenu }) => {
  const navigate = useNavigate();
  const [logoLoaded, setLogoLoaded] = useState(false);

  const { isDark, toggleTheme } = useTheme("dark");
  useEffect(() => {
    getTotalVolume();
    getFileCount();
  }, []);
  console.log("🚀 ~ Aside ~ isDark:", isDark);
  return (
    <Sider className={clsx("aside", { mobile: isMobileMenu })}>
      <div className="branding">
        {!logoLoaded && (
          <div style={{ position: "absolute" }}>
            <Spin size="small" />
          </div>
        )}
        <img
          src={isDark ? darkModeLogo : Logo}
          className="logo-icon"
          alt="Logo"
          onLoad={() => setLogoLoaded(true)}
          style={{
            opacity: logoLoaded ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
            height: "42px",
          }}
        />
      </div>

      <div className="menu">
        <MenuItems />
      </div>
      <StorageDetails />
    </Sider>
  );
};

export default Aside;
